import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { IChatGptPrompt } from "../googleSearchPrompt/dto/IChatGptPrompt";

interface IExportFormProps {
  setIsMenuOpened: React.Dispatch<SetStateAction<boolean>>;
  state: IChatGptPrompt | undefined;
  setState: React.Dispatch<SetStateAction<IChatGptPrompt | undefined>>;
}

export const DataEnrichmentCreate = ({
  setIsMenuOpened,
  state,
  setState,
}: IExportFormProps) => {
  const { t } = useTranslation();
  const changeHandler = (event: any) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col md={4}>
            <label htmlFor="name" className="required-field ">
              {`${t("global.title")}`}
            </label>
            <input
              type="text"
              name="title"
              className="form-control mb-2"
              value={state?.title ?? ""}
              required
              onChange={(e) => changeHandler(e as any)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <label htmlFor="prompt" className="required-field">
              {`${t("google_search.prompt")}`}
            </label>
            <textarea
              name="prompt"
              onChange={(e) => changeHandler(e as any)}
              value={(state as any)?.prompt ?? ""}
              className="w-100 dark-text-area"
              placeholder={`${t("mapping.type")}...`}
              rows={12}
            />
          </Col>
          <div
            className="alert alert-warning alert-borderless m-0 p-1"
            role="alert"
          >
            <p className="mb-0">
              <strong>{t("data_enrichment.html_necessary_tag")}!</strong>
            </p>
          </div>
        </Row>
        <div className="col-12 my-2 d-flex justify-content-end text-align-center">
          <div>
            <button
              className="btn btn-info"
              onClick={() => {
                setIsMenuOpened(false);
                setState({} as any);
              }}
            >
              {t("global.cancel")}
            </button>
            <button className="btn btn-primary ms-3" type="submit">
              {state?.id ? `${t("global.update")}` : `${t("global.create")}`}
            </button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
